<section class="providers-page">

  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <div class="page-header">
    <h1>Providers</h1>
  </div>

  <!-- ── Filter bar ─────────────────────────────────────────────────────── -->
  <op-filter-bar
    searchPlaceholder="Search providers by name"
    [config]="filterConfig"
    [initialValues]="filterInitialValues()"
    [categoryOptions]="categoryOptions()"
    [cityOptions]="cityOptions()"
    (filterChange)="onFilterChange($event)"
  />

  <!-- ── Table ────────────────────────────────────────────────────────────── -->
  <div class="table-panel">
    @if (loading()) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
    } @else if (error()) {
      <div class="empty error-text">{{ error() }}</div>
    } @else {
      <div class="table-wrap">
        @if (providers().length) {
          <table>
            <thead>
              <tr>
                <th>Provider</th>
                <th>Categories</th>
                <th>Cities</th>
                <th>Last assigned</th>
                <th class="numeric-th">Orders</th>
                <th>Trust</th>
                <th>Insurance</th>
                <th>Active</th>
                <th>Contact</th>
                <th class="actions-th"></th>
              </tr>
            </thead>
            <tbody>
              @for (p of providers(); track p.id) {
                <tr>

                  <!-- Name -->
                  <td class="name-cell">
                    <span class="provider-name">{{ p.name }}</span>
                  </td>

                  <!-- Categories -->
                  <td class="categories-cell">
                    <span class="cell-text">{{ categoryNamesFor(p) }}</span>
                  </td>

                  <!-- Cities -->
                  <td class="cities-cell">
                    <span class="cell-text">{{ cityLabelsFor(p) }}</span>
                  </td>

                  <!-- Last assigned -->
                  <td class="last-assigned-cell">
                    <span class="cell-text">{{ lastAssignedLabel(p) }}</span>
                  </td>

                  <!-- Assigned orders count -->
                  <td class="numeric-cell">{{ p.assigned_orders_count }}</td>

                  <!-- Trust status -->
                  <td class="trust-cell">
                    <span class="trust-chip trust-chip--{{ p.trust_status }}">
                      {{ trustLabel(p.trust_status) }}
                    </span>
                  </td>

                  <!-- Insurance -->
                  <td class="bool-cell">
                    @if (p.insurance_verified) {
                      <span class="bool-chip bool-chip--yes">Yes</span>
                    } @else {
                      <span class="bool-chip bool-chip--no">No</span>
                    }
                  </td>

                  <!-- Active -->
                  <td class="bool-cell">
                    @if (p.is_active) {
                      <span class="bool-chip bool-chip--yes">Active</span>
                    } @else {
                      <span class="bool-chip bool-chip--no">Inactive</span>
                    }
                  </td>

                  <!-- Contact -->
                  <td class="contact-cell">{{ contactLabel(p) }}</td>

                  <!-- Actions -->
                  <td class="actions-cell">
                    <a class="ghost-btn ghost-btn--small" [routerLink]="['/providers', p.id]">Open</a>
                  </td>

                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty">No providers found.</div>
        }
      </div>
    }
  </div>

</section>